<template>
    <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import { RecycleList, Floating, Tip, TabBar, TabPanels, TagGroup, Progress, LoadList, Scroll } from '@didi/rich-ui'
Vue.use(RecycleList)
Vue.use(Floating)
Vue.use(TabBar)
Vue.use(TabPanels)
Vue.use(TagGroup)
Vue.use(Progress)
Vue.use(Tip)
Vue.use(LoadList)
Vue.use(Scroll)

export default {
  name: 'xtd'
}
</script>
<style>
</style>
